const angular = require('angular');

class DropdownListenerController {
    public static $inject = ['$window'];
    constructor($window) {
        $window.onclick = (e) => {
            const barClickEvent: Event = new CustomEvent('clickOut');
            dispatchEvent(barClickEvent);
        };
    }
}

function DropdownListenerDirective() {
    return {
        restrict: 'A',
        controller: DropdownListenerController
    };
}

export default angular
    .module('spsng.components.dropdown.directive', [])
    .directive('dropdownListener', DropdownListenerDirective)
    .name;
